export enum RowActions {
  FETCH = 'r0',
  SHARED_ROW = 'r1',
}